import type { GoodsCoreModel, IScreensLogging } from '../../../../../api/types';
import { bridge, isNotNil } from '../../../../../utils';
import { AdAction } from '../../../../../utils/eventLogger/adLogger/types';

type LogOnPressLikeProps = {
  item: GoodsCoreModel;
  logging: IScreensLogging;
  currentLike: boolean;
};

export const logOnPressLike = ({
  logging,
  currentLike,
  item,
}: LogOnPressLikeProps) => {
  const name = currentLike ? 'CLICK_UNLIKE_GOODS' : 'CLICK_LIKE_GOODS';

  bridge.logAnalyticsEvent({
    name,
    analytics: logging.analytics,
    ably_only_log: logging.ably_only_log,
  });

  if (isNotNil(item.ad)) {
    bridge.logAdEvent({
      action: currentLike ? AdAction.UNLIKE : AdAction.LIKE,
      ad: item.ad,
    });
  }
};
